/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClusterNode } from './cluster-node';
import { EmployeesEmployeesEmployee } from './employees-employees-employee';
import { PositionRequestApproval } from './position-request-approval';
import { CountryClusterNode } from './country-cluster-node';
import { JobAd } from './job-ad';
import { Cluster } from './cluster';
import { MercerJobCode } from './mercer-job-code';
import { PositionRequestCandidate } from './position-request-candidate';
import { PositionRequestJobAd } from './position-request-job-ad';

export interface PositionRequest {
  /**
   * The unique id of the position request.
   */
  id: string;
  /**
   * The optional request title of the position request.
   */
  title?: string | null;
  hiringManager?: EmployeesEmployeesEmployee;
  /**
   * The id of the employee that created the position request.
   */
  createdById: string;
  createdBy?: EmployeesEmployeesEmployee;
  /**
   * The date the position request was created.
   */
  createdAt: string;
  /**
   * The unique id of the employee that last updated the position request.
   */
  updatedById: string;
  /**
   * The date the position request was last modified.
   */
  updatedAt: string;
  /**
   * The unique id of the employee that last updated the position request as emulation (or null if the last modification did not use emulation).
   */
  emulatedById?: string | null;
  /**
   * The type of position to request of the position request.
   */
  positionType: PositionRequestPositionTypeEnum;
  /**
   * Whether the leadership of the requested position is shared with another manager.
   */
  isSharedLeadership?: boolean;
  /**
   * The type of the position request.
   */
  requestType: PositionRequestRequestTypeEnum;
  /**
   * The previous incumbent gid of the position request.
   */
  previousIncumbentGid?: string | null;
  /**
   * The start date of the position request.
   */
  startDateAt: string;
  /**
   * The headcount number of the position request.
   */
  headcountNumber: number;
  /**
   * The contract type of the position request.
   */
  contractType: PositionRequestContractTypeEnum;
  /**
   * The temporary contract duration in months of the position request.
   */
  temporaryContractDurationInMonths?: number | null;
  /**
   * The source of headcount of the position request.
   */
  sourceOfHeadcount: PositionRequestSourceOfHeadcountEnum;
  /**
   * Whether the position request is within budget.
   */
  isWithinBudget: boolean;
  /**
   * Whether the position request is sga billable.
   */
  isSGABillable: boolean;
  /**
   * Whether the position request is billable.
   */
  isBillable: boolean;
  /**
   * Whether the position request\'s location is defined.
   */
  isLocationDefined: boolean;
  /**
   * The location type of the position request.
   */
  locationType?: PositionRequestLocationTypeEnum | null;
  /**
   * Hiring only in Core-Offices or ALSO in Non-Core-Offices
   */
  officeType?: PositionRequestOfficeTypeEnum | null;
  /**
   * The selected region clusters of the position request.
   */
  regionGeoClusterIds?: Array<string> | null;
  /**
   * The selected country cluster nodes of the position request.
   */
  countryGeoClusterNodeIds?: Array<string> | null;
  /**
   * The selected primary country cluster node.
   */
  primaryCountryClusterNodeId?: string | null;
  /**
   * The unique id of the n minus one level cluster node of the position request.
   */
  nMinusOneLevelClusterNodeId: string;
  /**
   * The org code of the position request.
   */
  orgCode: string | null;
  /**
   * The org level of the position request.
   */
  orgLevel?: number | null;
  /**
   * The reason of the position request.
   */
  reason?: string | null;
  /**
   * The reason description of the position request.
   */
  reasonDescription?: string | null;
  /**
   * The attachments of the position request.
   */
  attachmentIds: Array<string> | null;
  /**
   * The approvals of the position request.
   */
  approvals?: Array<PositionRequestApproval> | null;
  /**
   * The current approval state of the position request.
   */
  state: PositionRequestStateEnum;
  /**
   * The state of the position request.
   */
  positionRequestState: PositionRequestPositionRequestStateEnum;
  /**
   * The unique id of the mercer job code of the position request.
   */
  jobCodeId?: string | null;
  jobCode?: MercerJobCode;
  /**
   * Whether the position request is a german non senior management position.
   */
  isGermanPartialEvaluation?: boolean;
  /**
   * Whether the position class should be (or was) hidden.
   */
  isPositionClassHidden?: boolean;
  /**
   * The original proposed position class of the position request.
   */
  originalProposedPositionClass?: number | null;
  /**
   * The position class of the position request.
   */
  positionClass?: number | null;
  /**
   * The selected region clusters of the position request.
   */
  regionGeoClusters?: Array<Cluster> | null;
  /**
   * The selected country cluster nodes of the position request.
   */
  countryGeoClusterNodes?: Array<CountryClusterNode> | null;
  primaryCountryClusterNode?: CountryClusterNode;
  nMinusOneLevelClusterNode?: ClusterNode;
  /**
   * Whether the current requesting user could approve the position request.
   */
  canApprove?: boolean | null;
  /**
   * Whether the current requesting user could reject the position request.
   */
  canReject?: boolean | null;
  /**
   * Whether the current requesting user could veto the position request.
   */
  canVeto?: boolean | null;
  /**
   * Indicates whether the position request can be transferred to a new organisation.
   */
  isTransferable?: boolean;
  /**
   * External candidates for the positions from avature provided
   */
  externalCandidates?: Array<PositionRequestCandidate> | null;
  /**
   * Internal candidates for the positions
   */
  internalCandidates?: Array<PositionRequestCandidate> | null;
  /**
   * Possible workforce type of position request draft.
   */
  workforceType?: PositionRequestWorkforceTypeEnum;
  /**
   * WorkTimeType of the employee.
   */
  workTimeType?: PositionRequestWorkTimeTypeEnum | null;
  /**
   * WorkTimeType of the employee.
   */
  employmentPercentage?: number | null;
  /**
   * Auto generated Reference number for display reasons.
   */
  referenceNumber?: number;
  /**
   * Defined if position is excluded from PE.
   */
  isPositionEvaluationExcluded?: boolean;
  /**
   * The unique id of the job description of the position request.
   */
  jobDescriptionId?: string | null;
  /**
   * The converted file attachments that make up the final job description of the position request.
   */
  finalJobDescriptionAttachmentIds?: Array<string> | null;
  /**
   * The original file attachments that make up the final job description of the position request.
   */
  originalFinalJobDescriptionAttachmentIds?: Array<string> | null;
  finalJobAd?: JobAd;
  /**
   * Optional cost center assigned to this request
   */
  costCenter?: string | null;
  /**
   * Optional are code assigned to this request
   */
  areCode?: string | null;
  /**
   * Optional depth structure assigned to this request
   */
  depthStructure?: string | null;
  /**
   * The job ads stored with this request, one per matching template. Empty when the request has no job ad and belongs in the classic tools. Unrelated to the legacy `FinalJobAd`.
   */
  jobAds?: Array<PositionRequestJobAd> | null;
}
export enum PositionRequestPositionTypeEnum {
  Head = 'Head',
  Employee = 'Employee'
}
export enum PositionRequestRequestTypeEnum {
  Addition = 'Addition',
  Replacement = 'Replacement'
}
export enum PositionRequestContractTypeEnum {
  Permanent = 'Permanent',
  Temporary = 'Temporary'
}
export enum PositionRequestSourceOfHeadcountEnum {
  Intern = 'Intern',
  Extern = 'Extern',
  Both = 'Both'
}
export enum PositionRequestLocationTypeEnum {
  BestCost = 'BestCost',
  HighCost = 'HighCost'
}
export enum PositionRequestOfficeTypeEnum {
  CoreOffice = 'CoreOffice',
  NonCoreOffice = 'NonCoreOffice'
}
export enum PositionRequestStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
export enum PositionRequestPositionRequestStateEnum {
  Planned = 'Planned',
  Draft = 'Draft',
  Submitted = 'Submitted',
  GlobalHrApprover = 'GlobalHrApprover',
  RegionalHrApprover = 'RegionalHrApprover',
  CbApprover = 'CbApprover',
  NMinusOneApprover = 'NMinusOneApprover',
  NMinusTwoApprover = 'NMinusTwoApprover',
  HeadOneApprover = 'HeadOneApprover',
  HeadTwoApprover = 'HeadTwoApprover',
  HeadNMinusOneApprover = 'HeadNMinusOneApprover',
  HeadNMinusTwoApprover = 'HeadNMinusTwoApprover',
  HeadNMinusThreeApprover = 'HeadNMinusThreeApprover',
  SelfValidation = 'SelfValidation',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
  Vetoed = 'Vetoed'
}
export enum PositionRequestWorkforceTypeEnum {
  Employee = 'Employee',
  Apprentice = 'Apprentice',
  Intern = 'Intern',
  Student = 'Student',
  BlueCollar = 'BlueCollar',
  LeasedWhiteCollar = 'LeasedWhiteCollar',
  LeasedBlueCollar = 'LeasedBlueCollar',
  Internal = 'Internal'
}
export enum PositionRequestWorkTimeTypeEnum {
  Either = 'Either',
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}
